import { Injectable, Output, EventEmitter } from '@angular/core';
import { PatientSearchResult, PatientService } from './patient.service';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BecareService } from './becare.service';
import * as moment from 'moment';
import { UserConfigService } from './user-config.service';
import { Kmehrhcparty } from '../models/kmehr/kmehrhcparty';
import { hi } from 'date-fns/locale';

declare var gUserId: number;

export class WaitingMessageResult {
    constructor(public result: any) {
    }
}
export class SendWaitingMessageResult {
    constructor(public result: any) {
    }
}
export class ListMessageResult {
    constructor(public result: any) {
    }
}
export class ListSendMessageResult {
    constructor(public result: any) {
    }
}
export class SendMessageResult {
    constructor(public result: any) {
    }
}
export class SendMessageEHealth {
    constructor(
        public destination: EHealthAddressbook,
        public patient: PatientSearchResult,
        public message: string) {
    }
}
export class MessageResult {
    constructor(public message: any, public result: any) {
    }
}
export class AddressbookSearchResult {
    constructor(public result: any) {
    }
}
export class EHealthAddressbook {
    constructor(public addr: any) {
    }
}

export interface MessageRetrieveEvent {
    all: boolean;
    messageid: number;
}
export interface TransactionRetrieveEvent {
    all: boolean;
    messageid: number;
}
export class KMEHRid {
    constructor(
        public sv: string,
        public sl: string,
        public dn: string,
        public l: string,
        public value: string) {
    }
}

export enum dmgerror {
    none = 'none',
    failed = 'failed',
    notauthorized = 'notauthorized',
    patient = 'patient'
}

export class EHealthDmgListResult {
    constructor(public result) {}
}

export class EHealthDmgMessageInscriptionPayment {
    constructor(public amount, public currency, public date) {}

    get dateAsString(): string {
        return moment(this.date).format('DD-MM-YYYY');
    }
}

export class EHealthDmgMessagesInscription {
    public hcParty: Kmehrhcparty;

    constructor(public inscription) {
        this.hcParty = new Kmehrhcparty();
        this.hcParty.fromJson(inscription.hcParty);
    }

    get fromAsString(): string {
        return moment(this.inscription.from).format('DD-MM-YYYY');
    }

    get toAsString(): string {
        return moment(this.inscription.to).format('DD-MM-YYYY');
    }
}

export class EHealthDmgMessagesList {
    public inscriptions: EHealthDmgMessagesInscription[];

    constructor(public list) {
        this.inscriptions = [];
        if (typeof(list.inscriptions) !== 'undefined' && Array.isArray(list.inscriptions)) {
            // tslint:disable-next-line:max-line-length
            (list.inscriptions as Array<any>).forEach(ainscription => this.inscriptions.push(new EHealthDmgMessagesInscription(ainscription)));
        }
    }
}

export class EHealthDmgMessages {
    public lists: EHealthDmgMessagesList[];
    constructor(public result) {
        this.lists = [];
        if (typeof(result.lists) !== 'undefined' && Array.isArray(result.lists)) {
            (result.lists as Array<any>).forEach(alist => this.lists.push(new EHealthDmgMessagesList(alist)));
        }
    }
}

@Injectable({
  providedIn: 'root'
})
export class EHealthService {

  private static instance: EHealthService = null;

  private localStorage: any;
  private isBrowserTrustedFlag = false;
  private certificateAvailableFlag = false;
  private certificate: string = null;
  private certificatetype: string = null;
  private password: string = null;
  private certificatealt: string = null;
  private certificatealttype: string = null;
  private passwordalt: string = null;
  private userid = -1;
  private keystore: any = null;
  private checkWaitingMessageInterval: any = null;
  private checkMessagePolling = false;
  public connectionstatus = 'nocertificate';
  public connectionmessage = '';
  public messages = {
      counter: 0,
      freespace: 0,
      status: ''
  };
  public outmessages = {
      counter: 0
  };
  public consent = {
      consent: false,
      message: ''
  };
  public dmg = {
      dmg: false,
      error: dmgerror.none,
      warning: false,
      message: '',
      result: {
          inss: '',
          firstName: '',
          lastName: '',
          birthday: '',
          sex: '',
          mutuality: '',
          from: '',
          to: '',
          payment: false,
          hcParty: null
      }
  };
  public therlink = {
      link: false,
      message: ''
  };
  public insurability = {
      active: false,
      error: false,
      message: '',
      ct1: '',
      ct2: '',
      mutuality: '',
      periodStart: '',
      periodEnd: ''
  };
  public messagelist = [];
  public messagesendlist = [];
  public therlinks = {
      status: 'none',
      error: false,
      message: '',
      links: []
  };
  public transactions = {
      status: 'none',
      error: false,
      message: '',
      list: []
  };

  @Output() messageRetrieveEvent = new EventEmitter<MessageRetrieveEvent>();
  @Output() transactionRetrieveEvent = new EventEmitter<TransactionRetrieveEvent>();

  constructor(private http: HttpClient, private cookies: CookieService,
              private becare: BecareService, private userconfig: UserConfigService,
              private patient: PatientService) {
    console.log('Hello EHealthProvider Provider');
    EHealthService.instance = this;
    this.localStorage = (typeof window !== 'undefined') ? window.localStorage : null;
    if (this.localStorage === null) {
        console.warn('local storage is not availaible');
    }
    // Check if the certificate is available
    this.becare.authStatus().subscribe(status => {
        if (status === true) {
            this.userid = this.becare.userid;
            this.checkCertificate();
        }
    });
    this.userid = -1;
    if (this.checkMessagePolling) {
        this.startCheckingWaitingMessage();
    }
  }

  public static getInstance(): EHealthService {
    return EHealthService.instance;
  }

  private startCheckingWaitingMessage() {
    this.checkWaitingMessageInterval = setInterval(() => {
        this.checkWaitingMessages();
    }, 10000);
  }

  private checkWaitingMessages() {
    console.log('Check message waiting');
    // Check messages
    this.sendWaitingMessage().subscribe();
  }

  public checkCertificate() {
    this.certificate = this.outstore(this.userconfig.userid.toString() + 'ehdata');
    this.certificatetype = this.outstore(this.userconfig.userid.toString() + 'ehdatat');
    this.password = this.outstore(this.userconfig.userid.toString() + 'ehdatap');
    this.certificatealt = this.outstore(this.userconfig.userid.toString() + 'ehdataalt');
    this.certificatealttype = this.outstore(this.userconfig.userid.toString() + 'ehdatatalt');
    this.passwordalt = this.outstore(this.userconfig.userid.toString() + 'ehdatapalt');
    if (this.certificate !== null && this.password !== null) {
      this.certificateAvailableFlag = true;
      this.isBrowserTrustedFlag = true;
      this.connect();
    } else {
      this.certificateAvailableFlag = false;
    }
  }

  get isBrowserTrusted(): boolean {
      return this.isBrowserTrustedFlag;
  }

  set isBrowserTrusted(isTrusted: boolean) {
    if (isTrusted === false) {
      // Clean localStorage
      this.cleanData();
      this.checkCertificate();
    }
    this.isBrowserTrustedFlag = isTrusted;
  }

  get certificateAvailable(): boolean {
    return this.certificateAvailableFlag;
  }

  setCertificate(certificate) {
    this.certificate = certificate;
    if (this.isBrowserTrusted) {
      this.store(this.userconfig.userid.toString() + 'ehdata', certificate);
    }
    this.checkCertificate();
  }

  setCertificateType(type) {
    this.certificatetype = type;
    if (this.isBrowserTrusted) {
      this.store(this.userconfig.userid.toString() + 'ehdatat', type);
    }
    this.checkCertificate();
  }

  setPassword(password) {
     this.password = password;
     if (this.isBrowserTrusted) {
        this.store(this.userconfig.userid.toString() + 'ehdatap', password);
     }
     this.checkCertificate();
  }

  setAltCertificate(certificate) {
    this.certificatealt = certificate;
    if (this.isBrowserTrusted) {
      this.store(this.userconfig.userid.toString() + 'ehdataalt', certificate);
    }
  }

  setAltCertificateType(type) {
    this.certificatealttype = type;
    if (this.isBrowserTrusted) {
      this.store(this.userconfig.userid.toString() + 'ehdatatalt', type);
    }
    this.checkCertificate();
  }

  setAltPassword(password) {
    this.passwordalt = password;
    if (this.isBrowserTrusted) {
      this.store(this.userconfig.userid.toString() + 'ehdatapalt', password);
    }
  }

  cleanData() {
    this.cleanstore(this.userconfig.userid.toString() + 'ehdata');
    this.cleanstore(this.userconfig.userid.toString() + 'ehdatat');
    this.cleanstore(this.userconfig.userid.toString() + 'ehdatap');
    this.cleanstore(this.userconfig.userid.toString() + 'ehdataalt');
    this.cleanstore(this.userconfig.userid.toString() + 'ehdatatalt');
    this.cleanstore(this.userconfig.userid.toString() + 'ehdatapalt');
  }

  private store(key, value) {
    if (this.localStorage !== null) {
        this.localStorage.setItem(key, value);
    }
  }

  private outstore(key) {
    if (this.localStorage !== null) {
        return this.localStorage.getItem(key);
    }
    return null;
  }

  private cleanstore(key) {
    if (this.localStorage !== null) {
        this.localStorage.removeItem(key);
    }
  }

  public connect() {
    if (this.certificateAvailableFlag === false) {
        return false;
    }
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    this.connectionstatus = 'connecting';
    this.connectionmessage = '';
    this.keystore = null;

    const postvalues = {
      password: this.password,
      certificate: this.certificate,
      type: this.certificatetype,
      passwordalt: null,
      certificatealt: null,
      typealt: null
    };
    if (this.passwordalt !== null && this.certificatealt !== null) {
      postvalues.passwordalt = this.passwordalt;
      postvalues.certificatealt = this.certificatealt;
      postvalues.typealt = this.certificatealttype;
    }
    this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/connect', postvalues)
    .subscribe(result => {
        if (result.success === true && result.status === 'connected') {
          this.connectionstatus = 'connected';
          this.keystore = result.keystore;
          // Check messages
          this.waitingMessage().subscribe();
        } else {
          this.connectionstatus = 'failed';
          if (typeof result.message !== 'undefined') {
              this.connectionmessage = result.message;
          }
        }
    });
  }

  public waitingMessage(): Observable<WaitingMessageResult> {
/*      if (this._certificateAvailable === false)
      {
          return Observable.create(result => {
              return false;
          });
      }*/
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/waiting', {
        password: this.password
    }).pipe(map(result => {
      if (result.success === true) {
          this.messages.counter = result.result.count;
          this.messages.freespace = result.result.spaceLeft;
          return new WaitingMessageResult(result);
      } else {
          this.connectionstatus = 'failed';
          if (typeof result.message !== 'undefined') {
              this.connectionmessage = result.message;
          }
      }
    }));
  }

  public sendWaitingMessage(): Observable<SendWaitingMessageResult> {
    if (typeof gUserId !== 'undefined') {
      this.userid = gUserId;
    }
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/sendwaiting', {
        password: this.password
    }).pipe(map(result => {
      if (result.success === true) {
        this.outmessages.counter = result.result.count;
        return new SendWaitingMessageResult(result);
      } else {
        this.connectionstatus = 'failed';
        if (typeof result.message !== 'undefined') {
            this.connectionmessage = result.message;
        }
      }
    }));
  }

  public sendListMessage(): Observable<ListSendMessageResult> {
      if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
      }
      return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/sendlist', {
          password: this.password
      }).pipe(map(result => {
          if (result.success === true) {
              this.messagesendlist = result.result;
              return new ListSendMessageResult(result);
          } else {
              this.messagesendlist = [];
              this.connectionstatus = 'failed';
              if (typeof result.message !== 'undefined') {
                  this.connectionmessage = result.message;
              }
          }
      }));
  }

  public sendDeleteMessage(messageid): Observable<boolean> {
      if (typeof gUserId !== 'undefined') {
          this.userid = gUserId;
      }
      return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/' + messageid + '/senddelete', {
          password: this.password
      })
      .pipe(map(result => {
        if (result.success === true) {
            return true;
        } else {
            this.connectionstatus = 'failed';
            if (typeof result.message !== 'undefined') {
                this.connectionmessage = result.message;
            }
            return false;
        }
      }));
  }

  public listMessage(): Observable<ListMessageResult> {
      if (typeof gUserId !== 'undefined') {
          this.userid = gUserId;
      }
      return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/list', {
          password: this.password
      })
      .pipe(map(result => {
        if (result.success === true) {
            this.messagelist = result.result;
            return new ListMessageResult(result);
        } else {
            this.messagelist = [];
            this.connectionstatus = 'failed';
            if (typeof result.message !== 'undefined') {
                this.connectionmessage = result.message;
            }
        }
      }));
  }

  public message(messageid): Observable<MessageResult> {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    const postvalues = {
      password: this.password,
      passwordalt: null
    };
    if (this.passwordalt !== null) {
        postvalues.passwordalt = this.passwordalt;
    }
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/' + messageid, postvalues)
    .pipe(map(result => {
        console.log(result);
        if (result.success === true) {
            return new MessageResult(result.message, result.result);
        } else {
            this.connectionstatus = 'failed';
            if (typeof result.message !== 'undefined') {
                this.connectionmessage = result.message;
            }
            return new MessageResult(result.message, false);
        }
    }));
  }

  public startmessageretrieving() {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    const postvalues = {
        phpsessionid: this.cookies.get('PHPSESSID'),
        password: this.password,
        passwordalt: null,
        keystore: this.keystore
    };
    if (this.passwordalt !== null) {
        postvalues.passwordalt = this.passwordalt;
    }
    this.http.post('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/retrieve', postvalues).subscribe();
    this.messageRetrieveEvent.emit({
        all: true,
        messageid: -1
    });
  }

  public retrievemessage(messageid) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    const postvalues = {
        phpsessionid: this.cookies.get('PHPSESSID'),
        password: this.password,
        passwordalt: null,
        keystore: this.keystore
    };
    if (this.passwordalt !== null) {
        postvalues.passwordalt = this.passwordalt;
    }
    this.http.post('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/retrieve/' + messageid, postvalues).subscribe();
    this.messageRetrieveEvent.emit({
        all: false,
        messageid
    });
  }

  public deletemessage(messageid) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    const postvalues = {
        phpsessionid: this.cookies.get('PHPSESSID'),
        password: this.password,
        passwordalt: null,
        keystore: this.keystore
    };
    if (this.passwordalt !== null) {
        postvalues.passwordalt = this.passwordalt;
    }
    this.http.post('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/delete/' + messageid, postvalues).subscribe();
  }

  public sendMessage(message: SendMessageEHealth) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    const postvalues = {
        phpsessionid: this.cookies.get('PHPSESSID'),
        password: this.password,
        keystore: this.keystore,
        message
    };
    this.http.post('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/send', postvalues).subscribe();
  }

  public sendAllMessages() {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    const postvalues = {
        phpsessionid: this.cookies.get('PHPSESSID'),
        password: this.password,
        passwordalt: null,
        keystore: this.keystore
    };
    if (this.passwordalt !== null) {
        postvalues.passwordalt = this.passwordalt;
    }
    this.http.post('/api/v1/ehealth/user/' + this.userid + '/ehbox/message/send/all', postvalues).subscribe();
  }

  public search(query) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/addressbook/search', {
        password: this.password,
        query
    })
    .pipe(map(result => {
        if (result.success === true) {
            return new AddressbookSearchResult(result.result);
        } else {
            this.connectionstatus = 'failed';
            if (typeof result.message !== 'undefined') {
                this.connectionmessage = result.message;
            }
        }
    }));
  }

  public patientconsent(patientid) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    // Reset patient consent
    this.consent.consent = false;
    this.consent.message = '';
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/patient/' + patientid + '/consent', {
        password: this.password
    })
    .pipe(map(result => {
        if (result.success === true) {
            if (typeof(result.result) !== 'undefined' && result.result.complete === true) {
                this.consent.consent = true;
                let message = '';
                if (typeof(result.result.author) !== 'undefined') {
                    message += 'Auteur : ' + (result.result.author.length === 0) ? 'Pas d\'auteur spécifié' : result.result.author;
                }
                if (typeof(result.result.timestamp) !== 'undefined') {
                    let consentDateString = '';
                    if (result.result.timestamp !== 0) {
                        const consentDate = new Date(0);
                        consentDate.setUTCSeconds(parseInt(result.result.timestamp, 10) / 1000);
                        consentDateString = 'Date : ' + consentDate.toLocaleDateString();
                    } else {
                        consentDateString = 'Pas de date spécifiée';
                    }
                    message += ', ' + consentDateString;
                }
                this.consent.message = message;
            } else {
                if (typeof(result.result) !== 'undefined' && typeof(result.result.errors) !== 'undefined') {
                    this.consent.message = result.result.errors[0].descr;
                }
            }
            return result;
        } else {
            if (typeof(result.status) !== 'undefined') {
                this.connectionstatus = 'failed';
                if (typeof result.message !== 'undefined') {
                    this.connectionmessage = result.message;
                }
            } else {
                this.consent.message = result.message;
            }
        }
    }));
  }

  public patientdmg(patientid, date?: Date) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    // Reset patient dmg
    this.dmg.dmg = false;
    this.dmg.error = dmgerror.none;
    this.dmg.warning = false;
    this.dmg.message = '';
    this.dmg.result = {
        inss: '',
        firstName: '',
        lastName: '',
        birthday: '',
        sex: '',
        mutuality: '',
        from: '',
        to: '',
        payment: false,
        hcParty: null
    };
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/patient/' + patientid + '/dmg', {
        password: this.password,
        date: (typeof date === 'undefined') ? undefined : moment(date).format('x')
    })
    .pipe(map(result => {
        if (result.success === true) {
            if (result.result.complete && result.result.complete === true) {
                this.dmg.dmg = true;
                if (result.result.inss === null && result.result.from === null &&
                    result.result.to === null) {
                        // No info, the patient does not have a dmg
                        this.dmg.warning = true;
                        this.dmg.message = 'Le patient n\'a pas de eDMG, cliquez pour en créer un';
                    } else {
                        // patient have a dmg, find patient based on niss
                        this.patient.search(result.result.inss).subscribe(results => {
                            if (results.length !== 1) {
                                this.dmg.error = dmgerror.failed;
                                this.dmg.message = 'Multiples résultats pour ce patient, veuillez vérifier ces patients';
                                results.forEach(searchresult => {
                                    this.dmg.message += '<br>';
                                    this.dmg.message += searchresult.firstname + ' ' + searchresult.lastname;
                                    this.dmg.message += ' ' + searchresult.address + ' ' + searchresult.city;
                                });
                            } else {
                                // Compare result with patient record
                                const patientresult = results[0];
                                if (result.result.lastName.toUpperCase() !== patientresult.lastname.toUpperCase()) {
                                    this.dmg.message += 'Le nom de famille n\'est pas le même - ';
                                    this.dmg.error = dmgerror.patient;
                                }
                                if (!result.result.firstName.toUpperCase().includes(patientresult.firstname.toUpperCase())) {
                                    this.dmg.message += 'Le prénom n\'est pas le même - ';
                                    this.dmg.error = dmgerror.patient;
                                }
                                this.dmg.result.inss = result.result.inss;
                                this.dmg.result.firstName = result.result.firstName;
                                this.dmg.result.lastName = result.result.lastName;
                                this.dmg.result.birthday = (result.result.birthday < 1) ? '' : moment(result.result.birthday).format('DD/MM/YYYY');
                                this.dmg.result.sex = result.result.sex;
                                this.dmg.result.mutuality = result.result.mutuality;
                                this.dmg.result.from = (result.result.from < 1) ? '' : moment(result.result.from).format('DD/MM/YYYY');
                                this.dmg.result.to = (result.result.to < 1) ? '' : moment(result.result.to).format('DD/MM/YYYY');
                                this.dmg.result.payment = result.result.payment;
                                this.dmg.result.hcParty = result.result.hcParty;
                            }
                        });
                    }
            } else {
                let message = '';
                if (result.result.errors) {
                    result.result.errors.forEach(error => {
                        if (message.length !== 0) {
                            message += ' ,';
                        }
                        message += error.msgFr;
                    });
                }
                this.dmg.message = message;
                if (message.indexOf('SOA-01002') !== -1) {
                    this.dmg.error = dmgerror.notauthorized;
                } else {
                    this.dmg.error = dmgerror.failed;
                }
            }
        }
        return result;
    }));
  }

  public userdmglist(date?: Date, oa?: string) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/dmg/list', {
        password: this.password,
        date: (typeof date === 'undefined') ? undefined : moment(date).format('YYYYMMDD'),
        oa: (typeof oa === 'undefined') ? undefined : oa
    }).pipe(map(result => {
        const reqlist = new EHealthDmgListResult(result.result);
        return reqlist;
    }));
  }

  public dmgmessages(messages: string[]) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/dmg/messages', {
        password: this.password,
        messages
    }).pipe(map(result => {
        return new EHealthDmgMessages(result.result);
    }));
  }

  public confirmdmgmessages(messages: string[]) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/dmg/messages/confirm', {
        password: this.password,
        messages
    }).pipe(map(result => {
        return result;
    }));
  }

  public patienttherlink(patientid) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    // Reset patient therlink
    this.therlink.link = false;
    this.therlink.message = '';
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/patient/' + patientid + '/therlink', {
        password: this.password
    })
    .pipe(map(result => {
        if (result.success === true) {
            if (typeof(result.result) !== 'undefined' && result.result.complete === true) {
                this.therlink.link = true;
            } else {
                if (typeof(result.result) !== 'undefined' && typeof(result.result.errors) !== 'undefined') {
                    this.therlink.message = result.result.errors[0].descr;
                }
            }
            return result;
        } else {
            if (typeof(result.status) !== 'undefined') {
                this.connectionstatus = 'failed';
                if (typeof result.message !== 'undefined') {
                    this.connectionmessage = result.message;
                }
            } else {
                this.therlink.message = result.message;
            }
        }
    }));
  }

  public patientinsurability(patientid) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    // Reset patient insurability
    this.insurability.active = false;
    this.insurability.error = false;
    this.insurability.message = '';
    this.insurability.ct1 = '';
    this.insurability.ct2 = '';
    this.insurability.mutuality = '';
    this.insurability.periodStart = '';
    this.insurability.periodEnd = '';
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/patient/' + patientid + '/insurability', {
        password: this.password
    })
    .pipe(map(result => {
        if (result.success === true) {
            if (typeof(result.result) !== 'undefined' &&
                typeof(result.result.faultMessage) !== 'undefined' &&
                result.result.faultMessage !== null) {
                    if (typeof(result.result.errors) !== 'undefined' &&
                        Array.isArray(result.result.errors)) {
                        // Get error
                        this.insurability.message = result.result.errors[0].msgFr;
                        this.insurability.error = true;
                    } else {
                        this.insurability.message = result.result.faultMessage;
                        this.insurability.error = true;
                    }
            } else {
                this.insurability.active = true;
            }
            if (typeof(result.result.insurabilities) !== 'undefined' && result.result.insurabilities.length !== 0) {
                let message = '';
                const assurability = result.result.insurabilities[0];
                // Check periods
                const now = moment().startOf('day');
                const startPeriod = moment(assurability.period.periodStart.toString(), 'YYYYMMDD');
                const endPeriod = moment(assurability.period.periodEnd.toString(), 'YYYYMMDD');
                if (!(startPeriod.isSameOrBefore(now) && endPeriod.isSameOrAfter(now))) {
                    this.insurability.active = false;
                }
                this.insurability.ct1 = assurability.ct1;
                this.insurability.ct2 = assurability.ct2;
                this.insurability.mutuality = assurability.mutuality;
                this.insurability.periodStart = assurability.period.periodStart;
                this.insurability.periodEnd = assurability.period.periodEnd;
                message += 'ct1/ct2 = ' + assurability.ct1 + '/' + assurability.ct2 + '\\n';
                message += 'mutuelle = ' + assurability.mutuality + '\\n';
                message += 'période = ' + assurability.period.periodStart + ' -> ' + assurability.period.periodEnd;
                this.insurability.message = message;
            }
            return result;
        } else {
            this.insurability.message = 'Erreur lors de la récupération des données d\'assurabilité';
        }
    }));
  }

  public patienttherlinks(patientid) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    // Reset patient therlinks
    this.therlinks.status = 'retrieving';
    this.therlinks.error = false;
    this.therlinks.message = '';
    this.therlinks.links = [];
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/hub/patient/' + patientid + '/therlink', {
        password: this.password
    })
    .pipe(map(result => {
        console.log(result);
        if (result.success === true) {
            if (typeof(result.result.therapeuticLinks) !== 'undefined') {
                this.therlinks.status = 'done';
                this.therlinks.error = false;
                this.therlinks.links = result.result.therapeuticLinks;
                if (result.result.therapeuticLinks.length === 0) {
                    this.therlinks.message = '';
                } else {
                    this.therlinks.message = '';
                }
            } else {
                this.therlinks.status = 'error';
                this.therlinks.error = true;
                this.therlinks.message = result.result.message;
                this.therlinks.links = [];
            }
        } else {
            this.therlinks.status = 'error';
            this.therlinks.error = true;
            this.therlinks.message = result.message;
            this.therlinks.links = [];
        }
    }));
  }

  public patienttransactionlist(patientid) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    // Reset patient therlinks
    this.transactions.status = 'none';
    this.transactions.error = true;
    this.transactions.message = '';
    this.transactions.list = [];
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/hub/patient/' + patientid + '/transaction/list', {
        password: this.password
    })
    .pipe(map(result => {
        console.log(result);
        if (result.success === true) {
            if (typeof(result.result.error) !== 'undefined' && result.result.error.length !== 0) {
                this.transactions.status = 'error';
                this.transactions.error = true;
                this.transactions.message = result.result.message;
                this.transactions.list = [];
            } else {
                this.transactions.error = false;
                this.transactions.list = result.result;
                if (result.result.length !== 0) {
                    // Build message with links
                    this.transactions.message = result.result.length + ' documents sont présents sur les Hub';
                    this.transactions.status = 'some';
                } else {
                    this.transactions.message = 'Pas de documents disponible sur les Hub';
                    this.transactions.status = 'none';
                }
            }
        } else {
            this.transactions.status = 'error';
            this.transactions.error = true;
            this.transactions.message = result.message;
            this.transactions.list = [];
        }
    }));
  }

  public patientgettransaction(patientid, id: KMEHRid) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    // Reset patient therlinks
    // this.transactions.status = 'none';
    // this.transactions.error = false;
    // this.transactions.message = '';
    // this.transactions.list = [];
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/hub/patient/' + patientid + '/transaction/get', {
        password: this.password,
        id
    })
    .pipe(map(result => {
        console.log(result);
        if (result.success === true) {
            return result.result;
        }
    }));
  }

  public starttransactionretrieving(patientid) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    const postvalues = {
        phpsessionid: this.cookies.get('PHPSESSID'),
        password: this.password,
        passwordalt: null,
        keystore: this.keystore
    };
    if (this.passwordalt !== null) {
        postvalues.passwordalt = this.passwordalt;
    }
    this.http.post('/api/v1/ehealth/user/' + this.userid + '/hub/patient/' + patientid + '/transaction/retrieve/all', postvalues)
    .subscribe(result => {

    });
    this.transactionRetrieveEvent.emit({
        all: true,
        messageid: -1
    });
  }

  public prescriptionsend(prescription) {
    if (typeof gUserId !== 'undefined') {
        this.userid = gUserId;
    }
    return this.http.post<any>('/api/v1/ehealth/user/' + this.userid + '/prescription/' + prescription.id, {
        password: this.password
    })
    .pipe(map(result => {
        console.log(result);
        return result;
    }));
  }
}
